import { Avatar, Dropdown, Navbar } from "flowbite-react";
import { useSidebarContext } from "../../contexts/SidebarContext";
import isSmallScreen from "../../helpers/is-small-screen";
import { HiX, HiMenuAlt1 } from "react-icons/hi";
import { useAuth } from "../../contexts/AuthContext";
import { Link } from "react-router-dom";

const TopBar = () => {
  const { isOpenOnSmallScreens, isPageWithSidebar, setOpenOnSmallScreens } = useSidebarContext();

  return (
    <Navbar
      fluid
      theme={{
        root: {
          base: 'fixed z-30 w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700',
        },
      }}
    >
      <div className="w-full p-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {isPageWithSidebar && (
              <button
                onClick={() => setOpenOnSmallScreens(!isOpenOnSmallScreens)}
                className="mr-3 cursor-pointer rounded p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white lg:inline"
              >
                <span className="sr-only">Toggle sidebar</span>
                {isOpenOnSmallScreens && isSmallScreen() ? (
                  <HiX className="size-6" />
                ) : (
                  <HiMenuAlt1 className="size-6" />
                )}
              </button>
            )}
            <Navbar.Brand href="/">
              {process.env.REACT_APP_APP_NAME === 'InfluenceEasy' ? (
                <img
                  alt="InfluenceEasy"
                  src="/logo-ie.jpeg"
                  className="mr-3 h-6 sm:h-8"
                />
              ) : (
                <img
                  alt="GMG"
                  src="/logo-top.png"
                  className="mr-3 h-6 sm:h-8"
                  style={{
                    filter: 'brightness(0)'
                  }}
                />
              )}
            </Navbar.Brand>
          </div>
          <div className="flex items-center lg:gap-3">
            <div className="hidden lg:block">
              <UserDropdown />
            </div>
          </div>
        </div>
      </div>
    </Navbar>
  );
}

const UserDropdown = () => {
  const { user } = useAuth();

  return (
    <Dropdown
      arrowIcon={false}
      inline
      label={
        <span>
          <span className="sr-only">User menu</span>
          <Avatar
            alt=""
            rounded
            size="sm"
          />
        </span>
      }
    >
      <Dropdown.Header>
        <span className="block text-sm">{user.username}</span>
      </Dropdown.Header>
      <Dropdown.Item>
        <Link to="/profile">Settings</Link>
      </Dropdown.Item>
      <Dropdown.Item>
        <Link to="/logout">Sign out</Link>
      </Dropdown.Item>
    </Dropdown>
  );
};

export default TopBar;